import Swiper from 'swiper';
import { Grid, Navigation, Pagination } from 'swiper/modules';

function initializeSwiper() {
  const swiper = new Swiper('.brand-carousel__swiper', {
    speed: 400,
    spaceBetween: 8,
    slidesPerView: 2.4,
    modules: [Navigation, Pagination, Grid],
    navigation: {
      prevEl: '.brand-carousel__prev',
      nextEl: '.brand-carousel__next',
    },
    pagination: {
      type: 'fraction',
      el: '.swiper-pagination',
      renderFraction: (currentClass, totalClass) => {
        return `<span class="${currentClass}"></span> of <span class="${totalClass}"></span> `;
      },
    },
    grid: {
      fill: 'row',
      rows: 2,
    },
    breakpoints: {
      768: {
        spaceBetween: 12,
        slidesPerView: 'auto',
        grid: {
          rows: 1,
        },
      },
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeSwiper();
});
